/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AgentVariableDistribution200ResponseInner,
        CompetitiveRoundSummaries,
        CompetitiveRoundSummariesAggregate,
    } from '../models/index';

            export interface CompetitiveRoundSummariesAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                agent?: string;
                aggregates?: Array<string>;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game?: string;
                having?: object;
                index_on?: string;
                league?: string;
                map?: string;
                metrics?: Array<string>;
                patch?: string;
                plant_time?: number;
                player?: string;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                summary?: string;
                team1?: string;
                team2?: string;
            }

            export interface CompetitiveRoundSummariesFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                agent?: string;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game?: string;
                league?: string;
                map?: string;
                patch?: string;
                plant_time?: number;
                player?: string;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                summary?: string;
                team1?: string;
                team2?: string;
            }

            export interface CompetitiveRoundSummariesGetRequest {
                id: string;
            }

            export interface CompetitiveRoundSummariesListRequest {
                additional_filters?: object;
                agent?: string;
                annotations?: Array<string>;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game?: string;
                league?: string;
                map?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                patch?: string;
                plant_time?: number;
                player?: string;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                summary?: string;
                team1?: string;
                team2?: string;
            }

            export interface CompetitiveRoundSummariesVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                agent?: string;
                attack_pattern_full?: string;
                attack_pattern_short?: string;
                bomb_site?: string;
                callout_15s?: string;
                date?: string;
                defense_pattern_full?: string;
                defense_pattern_short?: string;
                first_attack_site?: string;
                freeze_time_end_timestamp?: number;
                game?: string;
                league?: string;
                map?: string;
                patch?: string;
                plant_time?: number;
                player?: string;
                round_eco_type?: string;
                round_eco_type_no_bonus?: string;
                round_id?: string;
                round_index?: number;
                shield?: string;
                side?: string;
                start_time_seconds?: number;
                summary?: string;
                team1?: string;
                team2?: string;
            }

        /**
        * 
        */
            export class CompetitiveRoundSummariesApi extends runtime.BaseAPI {

            /**
            */
            async competitiveRoundSummariesAggregateRaw(requestParameters: CompetitiveRoundSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveRoundSummariesAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling competitiveRoundSummariesAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveRoundSummariesAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.summary !== undefined) {
                            queryParameters['summary'] = requestParameters.summary;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveRoundSummaries/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: CompetitiveRoundSummariesAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveRoundSummariesAggregate>> {
                    const response = await this.competitiveRoundSummariesAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveRoundSummariesFieldValuesRaw(requestParameters: CompetitiveRoundSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling competitiveRoundSummariesFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling competitiveRoundSummariesFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.summary !== undefined) {
                            queryParameters['summary'] = requestParameters.summary;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveRoundSummaries/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: CompetitiveRoundSummariesFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.competitiveRoundSummariesFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveRoundSummariesGetRaw(requestParameters: CompetitiveRoundSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompetitiveRoundSummaries>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling competitiveRoundSummariesGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveRoundSummaries/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: CompetitiveRoundSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompetitiveRoundSummaries> {
                    const response = await this.competitiveRoundSummariesGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveRoundSummariesListRaw(requestParameters: CompetitiveRoundSummariesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CompetitiveRoundSummaries>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.summary !== undefined) {
                            queryParameters['summary'] = requestParameters.summary;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveRoundSummaries/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: CompetitiveRoundSummariesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CompetitiveRoundSummaries>> {
                    const response = await this.competitiveRoundSummariesListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async competitiveRoundSummariesVariableDistributionRaw(requestParameters: CompetitiveRoundSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling competitiveRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling competitiveRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling competitiveRoundSummariesVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling competitiveRoundSummariesVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.agent !== undefined) {
                            queryParameters['agent'] = requestParameters.agent;
                    }

                    if (requestParameters.attack_pattern_full !== undefined) {
                            queryParameters['attack_pattern_full'] = requestParameters.attack_pattern_full;
                    }

                    if (requestParameters.attack_pattern_short !== undefined) {
                            queryParameters['attack_pattern_short'] = requestParameters.attack_pattern_short;
                    }

                    if (requestParameters.bomb_site !== undefined) {
                            queryParameters['bomb_site'] = requestParameters.bomb_site;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.callout_15s !== undefined) {
                            queryParameters['callout_15s'] = requestParameters.callout_15s;
                    }

                    if (requestParameters.date !== undefined) {
                            queryParameters['date'] = requestParameters.date;
                    }

                    if (requestParameters.defense_pattern_full !== undefined) {
                            queryParameters['defense_pattern_full'] = requestParameters.defense_pattern_full;
                    }

                    if (requestParameters.defense_pattern_short !== undefined) {
                            queryParameters['defense_pattern_short'] = requestParameters.defense_pattern_short;
                    }

                    if (requestParameters.first_attack_site !== undefined) {
                            queryParameters['first_attack_site'] = requestParameters.first_attack_site;
                    }

                    if (requestParameters.freeze_time_end_timestamp !== undefined) {
                            queryParameters['freeze_time_end_timestamp'] = requestParameters.freeze_time_end_timestamp;
                    }

                    if (requestParameters.game !== undefined) {
                            queryParameters['game'] = requestParameters.game;
                    }

                    if (requestParameters.league !== undefined) {
                            queryParameters['league'] = requestParameters.league;
                    }

                    if (requestParameters.map !== undefined) {
                            queryParameters['map'] = requestParameters.map;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.patch !== undefined) {
                            queryParameters['patch'] = requestParameters.patch;
                    }

                    if (requestParameters.plant_time !== undefined) {
                            queryParameters['plant_time'] = requestParameters.plant_time;
                    }

                    if (requestParameters.player !== undefined) {
                            queryParameters['player'] = requestParameters.player;
                    }

                    if (requestParameters.round_eco_type !== undefined) {
                            queryParameters['round_eco_type'] = requestParameters.round_eco_type;
                    }

                    if (requestParameters.round_eco_type_no_bonus !== undefined) {
                            queryParameters['round_eco_type_no_bonus'] = requestParameters.round_eco_type_no_bonus;
                    }

                    if (requestParameters.round_id !== undefined) {
                            queryParameters['round_id'] = requestParameters.round_id;
                    }

                    if (requestParameters.round_index !== undefined) {
                            queryParameters['round_index'] = requestParameters.round_index;
                    }

                    if (requestParameters.shield !== undefined) {
                            queryParameters['shield'] = requestParameters.shield;
                    }

                    if (requestParameters.side !== undefined) {
                            queryParameters['side'] = requestParameters.side;
                    }

                    if (requestParameters.start_time_seconds !== undefined) {
                            queryParameters['start_time_seconds'] = requestParameters.start_time_seconds;
                    }

                    if (requestParameters.summary !== undefined) {
                            queryParameters['summary'] = requestParameters.summary;
                    }

                    if (requestParameters.team1 !== undefined) {
                            queryParameters['team1'] = requestParameters.team1;
                    }

                    if (requestParameters.team2 !== undefined) {
                            queryParameters['team2'] = requestParameters.team2;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/CompetitiveRoundSummaries/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: CompetitiveRoundSummariesVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.competitiveRoundSummariesVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
